// Generated from java-escape by ANTLR 4.11.1
// jshint ignore: start
import antlr4 from 'antlr4';


const serializedATN = [4,0,26,216,6,-1,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,
4,7,4,2,5,7,5,2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,7,
12,2,13,7,13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,2,19,7,19,
2,20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,24,7,24,2,25,7,25,1,0,1,0,1,1,
1,1,1,2,1,2,1,3,1,3,1,4,1,4,1,5,1,5,1,6,1,6,1,7,1,7,1,8,1,8,1,9,1,9,1,10,
1,10,1,11,1,11,1,12,1,12,1,13,1,13,1,13,1,14,1,14,1,14,1,15,1,15,1,15,1,
15,3,15,90,8,15,1,16,1,16,1,16,3,16,95,8,16,1,17,1,17,1,18,1,18,1,18,1,18,
1,18,3,18,104,8,18,1,19,1,19,1,19,1,19,3,19,110,8,19,1,20,1,20,1,20,1,20,
3,20,116,8,20,1,21,1,21,4,21,120,8,21,11,21,12,21,121,1,21,1,21,1,22,1,22,
5,22,128,8,22,10,22,12,22,131,9,22,1,23,4,23,134,8,23,11,23,12,23,135,1,
23,1,23,5,23,140,8,23,10,23,12,23,143,9,23,1,23,1,23,4,23,147,8,23,11,23,
12,23,148,3,23,151,8,23,1,23,1,23,4,23,155,8,23,11,23,12,23,156,1,23,1,23,
4,23,161,8,23,11,23,12,23,162,3,23,165,8,23,1,23,4,23,168,8,23,11,23,12,
23,169,3,23,172,8,23,1,24,1,24,1,24,1,24,1,24,1,24,1,24,1,24,5,24,182,8,
24,10,24,12,24,185,9,24,1,24,1,24,1,24,1,24,1,24,5,24,192,8,24,10,24,12,
24,195,9,24,1,24,1,24,1,24,1,24,1,24,5,24,202,8,24,10,24,12,24,205,9,24,
1,24,3,24,208,8,24,1,25,4,25,211,8,25,11,25,12,25,212,1,25,1,25,0,0,26,1,
1,3,2,5,3,7,4,9,5,11,6,13,7,15,8,17,9,19,10,21,11,23,12,25,13,27,14,29,15,
31,16,33,17,35,18,37,19,39,20,41,21,43,22,45,23,47,24,49,25,51,26,1,0,14,
2,0,65,65,97,97,2,0,78,78,110,110,2,0,68,68,100,100,2,0,79,79,111,111,2,
0,82,82,114,114,2,0,84,84,116,116,1,0,93,93,3,0,65,90,95,95,97,122,4,0,48,
57,65,90,95,95,97,122,1,0,48,57,1,0,96,96,1,0,34,34,1,0,39,39,3,0,9,10,13,
13,32,32,241,0,1,1,0,0,0,0,3,1,0,0,0,0,5,1,0,0,0,0,7,1,0,0,0,0,9,1,0,0,0,
0,11,1,0,0,0,0,13,1,0,0,0,0,15,1,0,0,0,0,17,1,0,0,0,0,19,1,0,0,0,0,21,1,
0,0,0,0,23,1,0,0,0,0,25,1,0,0,0,0,27,1,0,0,0,0,29,1,0,0,0,0,31,1,0,0,0,0,
33,1,0,0,0,0,35,1,0,0,0,0,37,1,0,0,0,0,39,1,0,0,0,0,41,1,0,0,0,0,43,1,0,
0,0,0,45,1,0,0,0,0,47,1,0,0,0,0,49,1,0,0,0,0,51,1,0,0,0,1,53,1,0,0,0,3,55,
1,0,0,0,5,57,1,0,0,0,7,59,1,0,0,0,9,61,1,0,0,0,11,63,1,0,0,0,13,65,1,0,0,
0,15,67,1,0,0,0,17,69,1,0,0,0,19,71,1,0,0,0,21,73,1,0,0,0,23,75,1,0,0,0,
25,77,1,0,0,0,27,79,1,0,0,0,29,82,1,0,0,0,31,89,1,0,0,0,33,94,1,0,0,0,35,
96,1,0,0,0,37,103,1,0,0,0,39,109,1,0,0,0,41,115,1,0,0,0,43,117,1,0,0,0,45,
125,1,0,0,0,47,171,1,0,0,0,49,207,1,0,0,0,51,210,1,0,0,0,53,54,5,40,0,0,
54,2,1,0,0,0,55,56,5,41,0,0,56,4,1,0,0,0,57,58,5,123,0,0,58,6,1,0,0,0,59,
60,5,125,0,0,60,8,1,0,0,0,61,62,5,43,0,0,62,10,1,0,0,0,63,64,5,45,0,0,64,
12,1,0,0,0,65,66,5,42,0,0,66,14,1,0,0,0,67,68,5,47,0,0,68,16,1,0,0,0,69,
70,5,37,0,0,70,18,1,0,0,0,71,72,5,94,0,0,72,20,1,0,0,0,73,74,5,38,0,0,74,
22,1,0,0,0,75,76,5,60,0,0,76,24,1,0,0,0,77,78,5,62,0,0,78,26,1,0,0,0,79,
80,5,60,0,0,80,81,5,61,0,0,81,28,1,0,0,0,82,83,5,62,0,0,83,84,5,61,0,0,84,
30,1,0,0,0,85,86,5,60,0,0,86,90,5,62,0,0,87,88,5,33,0,0,88,90,5,61,0,0,89,
85,1,0,0,0,89,87,1,0,0,0,90,32,1,0,0,0,91,95,5,61,0,0,92,93,5,61,0,0,93,
95,5,61,0,0,94,91,1,0,0,0,94,92,1,0,0,0,95,34,1,0,0,0,96,97,5,44,0,0,97,
36,1,0,0,0,98,99,5,38,0,0,99,104,5,38,0,0,100,101,7,0,0,0,101,102,7,1,0,
0,102,104,7,2,0,0,103,98,1,0,0,0,103,100,1,0,0,0,104,38,1,0,0,0,105,106,
5,124,0,0,106,110,5,124,0,0,107,108,7,3,0,0,108,110,7,4,0,0,109,105,1,0,
0,0,109,107,1,0,0,0,110,40,1,0,0,0,111,116,5,33,0,0,112,113,7,1,0,0,113,
114,7,3,0,0,114,116,7,5,0,0,115,111,1,0,0,0,115,112,1,0,0,0,116,42,1,0,0,
0,117,119,5,91,0,0,118,120,8,6,0,0,119,118,1,0,0,0,120,121,1,0,0,0,121,119,
1,0,0,0,121,122,1,0,0,0,122,123,1,0,0,0,123,124,5,93,0,0,124,44,1,0,0,0,
125,129,7,7,0,0,126,128,7,8,0,0,127,126,1,0,0,0,128,131,1,0,0,0,129,127,
1,0,0,0,129,130,1,0,0,0,130,46,1,0,0,0,131,129,1,0,0,0,132,134,7,9,0,0,133,
132,1,0,0,0,134,135,1,0,0,0,135,133,1,0,0,0,135,136,1,0,0,0,136,137,1,0,
0,0,137,141,5,46,0,0,138,140,7,9,0,0,139,138,1,0,0,0,140,143,1,0,0,0,141,
139,1,0,0,0,141,142,1,0,0,0,142,150,1,0,0,0,143,141,1,0,0,0,144,146,5,101,
0,0,145,147,7,9,0,0,146,145,1,0,0,0,147,148,1,0,0,0,148,146,1,0,0,0,148,
149,1,0,0,0,149,151,1,0,0,0,150,144,1,0,0,0,150,151,1,0,0,0,151,172,1,0,
0,0,152,154,5,46,0,0,153,155,7,9,0,0,154,153,1,0,0,0,155,156,1,0,0,0,156,
154,1,0,0,0,156,157,1,0,0,0,157,164,1,0,0,0,158,160,5,101,0,0,159,161,7,
9,0,0,160,159,1,0,0,0,161,162,1,0,0,0,162,160,1,0,0,0,162,163,1,0,0,0,163,
165,1,0,0,0,164,158,1,0,0,0,164,165,1,0,0,0,165,172,1,0,0,0,166,168,7,9,
0,0,167,166,1,0,0,0,168,169,1,0,0,0,169,167,1,0,0,0,169,170,1,0,0,0,170,
172,1,0,0,0,171,133,1,0,0,0,171,152,1,0,0,0,171,167,1,0,0,0,172,48,1,0,0,
0,173,183,5,96,0,0,174,182,8,10,0,0,175,176,5,96,0,0,176,177,5,96,0,0,177,
178,5,34,0,0,178,179,5,34,0,0,179,180,5,96,0,0,180,182,5,96,0,0,181,174,
1,0,0,0,181,175,1,0,0,0,182,185,1,0,0,0,183,181,1,0,0,0,183,184,1,0,0,0,
184,186,1,0,0,0,185,183,1,0,0,0,186,208,5,96,0,0,187,193,5,34,0,0,188,192,
8,11,0,0,189,190,5,34,0,0,190,192,5,34,0,0,191,188,1,0,0,0,191,189,1,0,0,
0,192,195,1,0,0,0,193,191,1,0,0,0,193,194,1,0,0,0,194,196,1,0,0,0,195,193,
1,0,0,0,196,208,5,34,0,0,197,203,5,39,0,0,198,202,8,12,0,0,199,200,5,39,
0,0,200,202,5,39,0,0,201,198,1,0,0,0,201,199,1,0,0,0,202,205,1,0,0,0,203,
201,1,0,0,0,203,204,1,0,0,0,204,206,1,0,0,0,205,203,1,0,0,0,206,208,5,39,
0,0,207,173,1,0,0,0,207,187,1,0,0,0,207,197,1,0,0,0,208,50,1,0,0,0,209,211,
7,13,0,0,210,209,1,0,0,0,211,212,1,0,0,0,212,210,1,0,0,0,212,213,1,0,0,0,
213,214,1,0,0,0,214,215,6,25,0,0,215,52,1,0,0,0,25,0,89,94,103,109,115,121,
129,135,141,148,150,156,162,164,169,171,181,183,191,193,201,203,207,212,
1,6,0,0];


const atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

const decisionsToDFA = atn.decisionToState.map( (ds, index) => new antlr4.dfa.DFA(ds, index) );

export default class InsightsQueryLexer extends antlr4.Lexer {

    static grammarFileName = "InsightsQuery.g4";
    static channelNames = [ "DEFAULT_TOKEN_CHANNEL", "HIDDEN" ];
	static modeNames = [ "DEFAULT_MODE" ];
	static literalNames = [ null, "'('", "')'", "'{'", "'}'", "'+'", "'-'", 
                         "'*'", "'/'", "'%'", "'^'", "'&'", "'<'", "'>'", 
                         "'<='", "'>='", null, null, "','" ];
	static symbolicNames = [ null, "LPAREN", "RPAREN", "LBRACE", "RBRACE", 
                          "PLUS", "MINUS", "MUL", "DIV", "MOD", "POW", "CONCAT", 
                          "LT", "GT", "LTE", "GTE", "NEQ", "EQ", "COMMA", 
                          "AND", "OR", "NOT", "ESCAPED_IDENTIFIER", "UNESCAPED_IDENTIFIER", 
                          "NUMBER", "STRING", "WHITESPACE" ];
	static ruleNames = [ "LPAREN", "RPAREN", "LBRACE", "RBRACE", "PLUS", "MINUS", 
                      "MUL", "DIV", "MOD", "POW", "CONCAT", "LT", "GT", 
                      "LTE", "GTE", "NEQ", "EQ", "COMMA", "AND", "OR", "NOT", 
                      "ESCAPED_IDENTIFIER", "UNESCAPED_IDENTIFIER", "NUMBER", 
                      "STRING", "WHITESPACE" ];

    constructor(input) {
        super(input)
        this._interp = new antlr4.atn.LexerATNSimulator(this, atn, decisionsToDFA, new antlr4.PredictionContextCache());
    }

    get atn() {
        return atn;
    }
}

InsightsQueryLexer.EOF = antlr4.Token.EOF;
InsightsQueryLexer.LPAREN = 1;
InsightsQueryLexer.RPAREN = 2;
InsightsQueryLexer.LBRACE = 3;
InsightsQueryLexer.RBRACE = 4;
InsightsQueryLexer.PLUS = 5;
InsightsQueryLexer.MINUS = 6;
InsightsQueryLexer.MUL = 7;
InsightsQueryLexer.DIV = 8;
InsightsQueryLexer.MOD = 9;
InsightsQueryLexer.POW = 10;
InsightsQueryLexer.CONCAT = 11;
InsightsQueryLexer.LT = 12;
InsightsQueryLexer.GT = 13;
InsightsQueryLexer.LTE = 14;
InsightsQueryLexer.GTE = 15;
InsightsQueryLexer.NEQ = 16;
InsightsQueryLexer.EQ = 17;
InsightsQueryLexer.COMMA = 18;
InsightsQueryLexer.AND = 19;
InsightsQueryLexer.OR = 20;
InsightsQueryLexer.NOT = 21;
InsightsQueryLexer.ESCAPED_IDENTIFIER = 22;
InsightsQueryLexer.UNESCAPED_IDENTIFIER = 23;
InsightsQueryLexer.NUMBER = 24;
InsightsQueryLexer.STRING = 25;
InsightsQueryLexer.WHITESPACE = 26;



